<template>
  <div v-if="model" class="guest-navbar navbar navbar-default navbar-fixed-top">
    <div class="container">
      <div class="navbar-header">
        <ul class="nav navbar-nav">
          <li v-if="!userNeedsToCompleteFoundationsSession" class="jyre-logo-container">
            <a data-test="guest-nav-jyre-logo" href="/home">
              <img
                src="../../assets/brand/gyre-logo-full-pill.png"
                alt="Gyre"
                class="gyre-top-nav-logo"
              />
            </a>
          </li>
        </ul>
      </div>

      <ul class="nav navbar-nav navbar-right">
        <li class="dropdown notifications">
          <UserNotificationsDropdown data-test="guest-nav-notification-bell" />
        </li>

        <GuestSettingsDropdown
          :showLinkToFoundationsSession="userNeedsToCompleteFoundationsSession"
        />
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import Debug from "debug";
import type { UserSelfDocumentApiModel } from "../../api-models";
import GuestSettingsDropdown from "../guest-settings-dropdown.vue";
import UserNotificationsDropdown from "../notifications/user-notifications-dropdown.vue";

const debug = Debug("cs.Navbar");

const props = defineProps<{
  model: UserSelfDocumentApiModel;
}>();

const userNeedsToCompleteFoundationsSession = computed(() => {
  return (
    props.model.platformPermissions.includes("FullMembershipAccess") &&
    !props.model.platformPermissions.includes("AdministerPlatform") &&
    !props.model.hasCompletedFoundationsSession
  );
});

onMounted(() => {
  debug("Mounted", props.model);
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

.gyre-top-nav-logo {
  height: @navbar-height;
}

.guest-navbar {
  .side-nav-toggle-btn:hover {
    .burger-menu,
    .burger-menu::before,
    .burger-menu::after {
      background: @navbar-default-link-hover-color;
    }
  }

  .jyre-logo-container {
    position: absolute;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100vw;

    a {
      padding: 0;
    }
  }

  @media (min-width: @screen-sm) {
    .notifications {
      margin-right: 15px;
    }
  }

  @media (max-width: 375px) {
    .gyre-top-nav-logo {
      margin-right: 20px;
    }
  }
}
</style>
